import React, { ReactNode, useState, useEffect } from "react";
import { Layout } from "antd";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import './StandartLayout.css';
import { useGlobalContext } from "../GlobalContext";

const { Content, Sider } = Layout;

interface StandartLayoutProps {
  children: ReactNode;
}

function StandartLayout({ children }: StandartLayoutProps) {
  const { isMobile, setIsMobile } = useGlobalContext();
  const [isCollapsed, setIsCollapsed] = useState(isMobile);
  const [showMobileOverlay, setShowMobileOverlay] = useState(false);

  // Reset collapsed state when mobile state changes
  useEffect(() => {
    setIsCollapsed(isMobile);
    setShowMobileOverlay(false);
  }, [isMobile]);

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
    if (isMobile) {
      setShowMobileOverlay(!isCollapsed);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header isMobile={isMobile} onMenuClick={handleCollapse} />
      
      <Layout style={{ 
        backgroundColor: 'var(--primary-bg-color)', 
        padding: isMobile ? '56px 0 0' : '100px 0 0',
      }}>
        {isMobile ? (
          <Sider 
            className={isCollapsed ? 'collapsed' : 'expanded'}
            width={250}
            collapsed={isCollapsed}
            collapsedWidth={0}
            theme="dark"
            trigger={null}
            style={{
              height: 'calc(100vh - 56px)',
              position: 'fixed',
              left: 0,
              top: '56px',
              backgroundColor: 'var(--primary-bg-color)',
              zIndex: 1000
            }}
          >
            <Sidebar toggleCollapsed={handleCollapse} collapsed={isCollapsed} />
          </Sider>
        ) : (
          <Sider 
            className={isCollapsed ? 'collapsed' : 'expanded'}
            width={250}
            collapsed={isCollapsed}
            collapsedWidth={80}
            theme="dark"
            trigger={null}
            style={{
              backgroundColor: 'var(--primary-bg-color)',
              position: 'fixed',
              left: 0,
              top: '100px',
              height: 'calc(100vh - 100px)',
              zIndex: 100,
            }}
          >
            <Sidebar toggleCollapsed={handleCollapse} collapsed={isCollapsed} />
          </Sider>
        )}

        <Layout className="site-layout">
          <Content className="side-content">
            <div className="side-content-wrapper">
              {children}
            </div>
          </Content>
        </Layout>
        
      </Layout>
    </Layout>
  );
}

export default StandartLayout;